module.exports = __webpack_public_path__ + "static/media/start1.15ddc101.svg";